(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sealand-tv"] && !Shopify.designMode) return;
  try {
    
  const our_family = document.getElementById('OurFamily');
  const gear = document.getElementById('Gear');
  const video_series = document.getElementById('VideoSeries');
  const together = document.getElementById('Together');
  
  const ourFamilyVideo = document.querySelectorAll('.our_family--block');
  const gearVideo = document.querySelectorAll('.gear--block');
  const videoSeriesVideo = document.querySelectorAll('.video_series--block');
  const togetherVideo = document.querySelectorAll('.together--block');

  our_family.addEventListener('click', function(){
    ourFamilyVideo.forEach(of => {of.style.display = 'block';});
    gearVideo.forEach(gv => {gv.style.display = 'none';});
    videoSeriesVideo.forEach(vsv => {vsv.style.display = 'none';});
    togetherVideo.forEach(tv => {tv.style.display = 'none';});
  });
  
    gear.addEventListener('click', function(){
    ourFamilyVideo.forEach(of => {of.style.display = 'none';});
    gearVideo.forEach(gv => {gv.style.display = 'block';});
    videoSeriesVideo.forEach(vsv => {vsv.style.display = 'none';});
    togetherVideo.forEach(tv => {tv.style.display = 'none';});
  });
    video_series.addEventListener('click', function(){
    ourFamilyVideo.forEach(of => {of.style.display = 'none';});
    gearVideo.forEach(gv => {gv.style.display = 'none';});
    videoSeriesVideo.forEach(vsv => {vsv.style.display = 'block';});
    togetherVideo.forEach(tv => {tv.style.display = 'none';});
  });
    together.addEventListener('click', function(){
    ourFamilyVideo.forEach(of => {of.style.display = 'none';});
    gearVideo.forEach(gv => {gv.style.display = 'none';});
    videoSeriesVideo.forEach(vsv => {vsv.style.display = 'none';});
    togetherVideo.forEach(tv => {tv.style.display = 'block';});
  });

  } catch(e) { console.error(e); }
})();
})();
